<template>
  <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
    <b-row class="m-0" v-if="hide_filter_drop_and_drop_Down">
      <b-col v-if="!sliderHide">
        <b-row>
          <b-col cols="4">
            <div class="float-left">
              <div class="filterText">Filter by Year:</div>
            </div>
          </b-col>
          <b-col cols="8">
            <div class="float-right">
              <b class="mr-3">{{ sliderValue[0] }}</b>
              <b-form-slider
                ref="mySlider"
                v-b-tooltip.hover
                :title="`${sliderValue[0]} - ${sliderValue[1]}`"
                :value="sliderValue"
                v-model="sliderValue"
                :min="min"
                :max="max"
                :range="range"
                @slide-stop="slideChange"
              >
              </b-form-slider>
              <b class="ml-3">{{ sliderValue[1] }}</b>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="yearDrop" cols="2">
        <b-form-select v-model="selectedYear" :options="yearOption">
          <template #first>
            <b-form-select-option :value="null" disabled
              >Select Base Year</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-col>
      <b-col class="text-right">
        <downloadChart :commitName="commitNameValue" />
      </b-col>
    </b-row>
    <b-row class="m-0 chartTabPanel autoCursor">
      <b-col class="p-0" ref="capture">
        <Plotly
          v-if="loaded && chartData && chartData.length"
          :layout="layout"
          :data="chartData"
          :display-mode-bar="false"
          :xAxisType="xAxisType"
          :yAxisType="getYAxisType"
          :margin="margin"
          :title="chartTitle"
          :name="name"
          :width="chartWidth"
          :heigth="chartHeight"
          :chartBarMode="chartBarMode"
          :tickFormat="tickFormat"
          :tickFormatX="tickFormatX"
          :tickFormatYaxis2="tickFormatYaxis2"
          :yAxisTitle="yAxisTitle"
          :ynticks="ynticks"
          :min="min"
          :max="max"
        /> </b-col
    ></b-row>
  </fullscreen>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "PlotlyMultiLineChart",
  props: {
    dataSet: {
      default: [],
    },
    xField: {
      default: "xField",
    },
    yField: {
      default: "yField",
    },
    name: {
      default: "",
    },
    range: { default: true },
    tickangle: {
      default: "auto",
    },
    margin: {
      default: {
        l: 80,
        r: 0,
        b: 0,
        t: 0,
        pad: 2,
      },
    },
    title: {
      default: "",
    },
    yAxisType: {
      default: "linear",
    },
    xAxisType: {
      default: "ordinal",
    },
    sliderHide: {
      default: false,
    },
    selectedYear: { default: null },
    yearOption: Array,
    yearDrop: {
      default: false,
    },
    hide_filter_drop_and_drop_Down: {
      default: true,
    },
    chartWidth: { default: "100%" },
    chartHeight: { default: "100%" },
    tickFormat: { default: "" },
    tickFormatX: { default: "" },
    tickFormatYaxis2: { default: "" },
    yAxisTitle: { default: "" },
    ynticks: { default: 4 },
    chartTitle: { default: "" },
    chartBarMode: { default: "" },
    commitName: {
      default: "",
      type: String,
    },
  },

  components: {
    Plotly,
    bFormSlider,
    downloadChart,
  },
  data() {
    return {
      loaded: this.dataSet && this.dataSet.length,
      layout: {},
      chartData: [],
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      min: "",
      max: "",
      sliderValue:
        this.dataSet &&
        this.dataSet.length &&
        this.dataSet[0] &&
        this.dataSet[0].year
          ? [
              Math.min.apply(Math, this.dataSet[0].year),
              Math.max.apply(Math, this.dataSet[0].year),
            ]
          : [],
      postDataCopy: JSON.stringify(this.dataSet),
      getChartWidth: this.chartWidth,
      getYAxisType: this.yAxisType,
      commitNameValue: this.commitName,
    };
  },
  created() {
    window.addEventListener("resize", this.windowResize);
    if (
      this.dataSet &&
      this.dataSet.length &&
      this.dataSet[0] &&
      this.dataSet[0].year
    ) {
      this.min = Math.min.apply(Math, this.dataSet[0].year);
      this.max = Math.max.apply(Math, this.dataSet[0].year);
      this.sliderValue = [this.min, this.max];
    }
    // console.log('check year-=-=range--=-=',this.dataSet,this.sliderValue,this.min);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  mounted() {
    this.createChart();
  },
  computed: {
    ...mapGetters({ isFullScreen: "isFullScreen" }),
  },
  methods: {
    ...mapActions(["setDownloadInfo"]),
    windowResize(e) {
      this.layout.width = this.$refs.capture.clientWidth - 50;
    },
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    createChart() {
      this.setDownloadInfo({
        fileName: this.title,
        downloadData: this.$refs.capture,
      });
      this.chartData = this.dataSet;
      if (this.chartData && this.chartData.length) {
        for (let i = 0; i < this.chartData.length; i++) {
          if (Object.keys(this.chartData[i]).includes("year")) {
            this.max = Math.max.apply(Math, this.chartData[i].year);
            this.min = Math.min.apply(Math, this.chartData[i].year);
            this.sliderValue = [this.min, this.max];
            break;
          }
        }
      }
      // console.log('this.chartBarMode',this.chartBarMode)
      //-------------Chart Layout-------------
      this.getChartWidth = this.$refs.capture.clientWidth - 50;
      this.layout = {
        title: this.title,
        margin: this.margin,
        minWidth: this.getChartWidth,
        height: this.chartHeight,
        barmode: this.chartBarMode,
        xaxis: {
          autorange: true,
          nticks: 12,
          rangeslider: {
            range: [],
            visible: false,
          },
          tickangle: this.tickangle,
          showgrid: false,
          showline: true,
          zeroline: true,
          linecolor: "#636363",
          anchor: "y",
          ticklen: 5,
        },
        yaxis: {
          autorange: true,
          nticks: this.ynticks,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          tickformat: this.tickFormat,
          title: {
            text: this.yAxisTitle,
            standoff: 150,
          },
        },
        yaxis2: {
          autorange: true,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          overlaying: "y",
          side: "right",
          tickformat: this.tickFormatYaxis2,
        },
        showlegend: true,
        legend: {
          x: 0.1,
          y: -0.6,
          orientation: "h",
        },
        traceorder: "normal",
        font: {
          family: "sans-serif",
          size: 12,
          color: "#000",
        },
        bgcolor: "#2E2EE2",
        bordercolor: "silver",
        borderwidth: 2,
      };
    },
    slideChange(e) {
      var newChartData = JSON.parse(this.postDataCopy);
      let filterData = [];
      if (newChartData && newChartData.length) {
        for (let j = 0; j < newChartData.length; j++) {
          let newData = newChartData[j];
          filterData.push({ x: [], y: [] });
          if (newData.x.length) {
            for (let i = 0; i < newData.x.length; i++) {
              if (
                newData.year &&
                newData.year[i] &&
                parseInt(newData.year[i]) >= parseInt(e[0]) &&
                parseInt(newData.year[i]) <= parseInt(e[1])
              ) {
                filterData[j].x.push(newData.x[i]);
                filterData[j].y.push(newData.y[i]);
              }
            }
          }

          //  console.log('new dataset-==',this.dataSet);
          this.dataSet[j].x = filterData[j].x;
          this.dataSet[j].y = filterData[j].y;
        }

        this.chartData.upperRange = e[1];
        this.chartData.lowerRange = e[0];

        this.sliderValue[0] = e[0];
        this.sliderValue[1] = e[1];
      }
    },
    yearChange() {
      //test
    },
  },
};
</script>
